/**
 * AssetImage — Renders an asset by ID using Convex getWithUrl.
 */
import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api';
import type { Id } from '../../convex/_generated/dataModel';
import { useAppStore } from '@/store/appStore';

type Props = {
  id: Id<'assets'> | string;
  className?: string;
  style?: React.CSSProperties;
  alt?: string;
};

export function AssetImage({ id, className, style, alt = '' }: Props) {
  const accountId = useAppStore((s) => s.currentAccountId) ?? undefined;
  const asset = useQuery(
    api.assets.getWithUrl,
    typeof id === 'string' && id.length > 0 ? { id: id as Id<'assets'>, accountId } : 'skip'
  );
  if (!asset?.url) return null;
  return (
    <img
      src={asset.url}
      alt={alt}
      className={className}
      style={style}
      crossOrigin="anonymous"
    />
  );
}
